import { isBrowser } from './utils';

const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent_v1';
const COOKIE_CONSENT_UPDATED_EVENT = 'regionalumzug24:cookie-consent-updated';

export type CookieConsentValue = 'all' | 'essential';

export type CookieConsentState = CookieConsentValue | null;

const VALID_VALUES: ReadonlySet<CookieConsentValue> = new Set<CookieConsentValue>([
  'all',
  'essential',
]);

export function getStoredCookieConsent(): CookieConsentState {
  if (!isBrowser()) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    if (VALID_VALUES.has(raw as CookieConsentValue)) {
      return raw as CookieConsentValue;
    }
    return null;
  } catch {
    return null;
  }
}

export function setStoredCookieConsent(value: CookieConsentValue): void {
  if (!isBrowser()) {
    return;
  }

  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, value);
    window.dispatchEvent(
      new CustomEvent<CookieConsentValue>(COOKIE_CONSENT_UPDATED_EVENT, { detail: value })
    );
  } catch {
    // Quota exceeded or storage disabled - silently ignore.
  }
}

export function clearStoredCookieConsent(): void {
  if (!isBrowser()) {
    return;
  }

  try {
    window.localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
    window.dispatchEvent(
      new CustomEvent<CookieConsentState>(COOKIE_CONSENT_UPDATED_EVENT, { detail: null })
    );
  } catch {
    // ignore
  }
}

export function isAnalyticsEnabledByConsent(state: CookieConsentState): boolean {
  return state === 'all';
}

export const COOKIE_CONSENT_EVENT_NAME = COOKIE_CONSENT_UPDATED_EVENT;
export const COOKIE_CONSENT_KEY = COOKIE_CONSENT_STORAGE_KEY;
